
import axios from '../plugins/axiosPlugins'

import runEvn from '../modular/runEvn/RunEvn'
const baseURL = runEvn().apiBaseUrl;

/**
 * 睦邻-友邻活动，新增
 * @returns 
 */
export const post = (data): Promise<any> => {
    return axios.post(`${baseURL}/NeighborActivity`, data);
}
//前端分页查询
export const getNeighborActivity = (data: any): Promise<any> => {
    return axios.get(`${baseURL}/NeighborActivity`, {params: data})
}
//前端分页查询 根据唯一id
export const getNeighborActivityById = (id: any): any => {
    return axios.get(`${baseURL}/NeighborActivity/${id}`)
}